import { Suspense, useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Skeleton } from '@ui';

import { useGetOpenBankingStatus } from '../../../../dataHelpers/OnlineAccounts/useGetOpenBankingStatus';
import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import { BankSelectionModal } from '../../../modals/BankSelectionModal/BankSelectionModal';
import { OpenBankingStatusCard } from '../../../ui/OpenBankingStatusCard/OpenBankingStatusCard';

export const OpenBankingStatusWidget = () => {
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense
                fallback={<Skeleton className="h-[140px] w-full rounded-s" />}
            >
                <OpenBankingStatusWidgetContent />
            </Suspense>
        </ErrorBoundary>
    );
};

const OpenBankingStatusWidgetContent = () => {
    const status = useGetOpenBankingStatus();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        tracking.ampli.track({
            event_type: 'OB Status Widget Displayed',
            event_properties: { status, source: 'dashboard_widget' }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAction = () => {
        tracking.ampli.track({
            event_type: 'OB Status Widget Action Clicked',
            event_properties: { status, source: 'dashboard_widget' }
        });
        setIsModalOpen(true);
    };

    return (
        <>
            <OpenBankingStatusCard status={status} onAction={handleAction} />
            <BankSelectionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};
